export default __webpack_public_path__ + "static/media/proximanova-semibold-webfont.d3769510.woff2";